import { combineReducers } from 'redux';

import { chatModalReducer } from './chatModal';
import { crossLinksReducer } from './crossLinks';
import { experimentsReducer } from './experiments';
import { jsonQueryReducer } from './filters';
import { datesModalReducer } from './filters/datesModalReducer';
import { tagsReducer } from './filters/tags';
import { filtersUrlReducer } from './filtersUrl';
import { journalHighlightsReducer } from './journalHighlights';
import { lastActionReducer } from './lastAction';
import { listingModalReducer } from './listingModal';
import { listingOffersReducer } from './listingOffers';
import { listingUrlReducer } from './listingUrl';
import { nonGeoParametersReducer } from './nonGeoParameters';
import { nonGeoQueryStringReducer } from './nonGeoQueryString';
import { notificationsReducer } from './notifications';
import { offersCountReducer } from './offersCount';
import { offersSuggestionsReducer } from './offersSuggestions';
import { platformReducer } from './platform';
import { queryStringReducer } from './queryString';
import { regionReducer } from './region';
import { regionIdReducer } from './regionId';
import { regionsReducer } from './regions';
import { resultsReducer } from './results';
import { searchResultsReducer } from './searchResults';
import { seoTabsLinksReducer } from './seoTabsLinks';
import { seoUrlReducer } from './seoUrl';
import { specialPromosReducer } from './specialPromos';
import { userReducer } from './user';
import { mapReducer } from '../../Map/reducers';
import { IFiltersState } from '../types/filters';
import { IApplicationState, TReduxActions } from '../types/redux';

export const reducers = combineReducers<IApplicationState, TReduxActions>({
  crossLinks: crossLinksReducer,
  experiments: experimentsReducer,
  filters: combineReducers<IFiltersState, TReduxActions>({
    jsonQuery: jsonQueryReducer,
    tags: tagsReducer,
    datesModal: datesModalReducer,
  }),
  filtersUrl: filtersUrlReducer,
  journalHighlights: journalHighlightsReducer,
  lastAction: lastActionReducer,
  listingUrl: listingUrlReducer,
  map: mapReducer,
  nonGeoQueryString: nonGeoQueryStringReducer,
  nonGeoParameters: nonGeoParametersReducer,
  notifications: notificationsReducer,
  offersCount: offersCountReducer,
  queryString: queryStringReducer,
  regionId: regionIdReducer,
  region: regionReducer,
  regions: regionsReducer,
  results: resultsReducer,
  searchResults: searchResultsReducer,
  seoUrl: seoUrlReducer,
  seoTabsLinks: seoTabsLinksReducer,
  specialPromos: specialPromosReducer,
  user: userReducer,
  listingOffers: listingOffersReducer,
  listingModal: listingModalReducer,
  chatModal: chatModalReducer,
  platform: platformReducer,
  offersSuggestions: offersSuggestionsReducer,
});
